import $ from 'jquery';
import axios from "axios";
import moment from "moment/moment";
import videojs from "video.js"
import { apiAxios, axiosLoc } from './axiosSetup'
import Clone, { reject } from 'lodash'
import 'jquery-datetimepicker/build/jquery.datetimepicker.full'

window.jQuery = $
window.$ = $
let map = new Map();

export const alarm_color = ['#ADD8E6', '#149126', '#ffd200', '#f36700', '#da0000', '#87c14f', '#6670cc', '#0d7cda', '#f3337b', '#133dd0', '#45b040', '#9e6606', '#2a2929'] //'보통', '안전', '주의', '경계', '심각', '높음', '낮음', '솔라', '우량', '수위', '유량' ,'단면', '기타 '
export const alarm_name = ['normal', 'safety', 'alert', 'alarm', 'critical', 'high', 'low', 'solar', 'rainfall', 'waterlevel', 'flow', 'cross_sections', 'etc'] // NORMAL, SAFETY("0"),ALERT("1"),ALARM("2"),CRITICAL("3"),HIGH("4"),LOW("5"),SOLAR("6"),RAINFALL("7"),WATERLEVEL(8), FLOW(9),CROSS SECTION(10),ETC(11)';

// axios.defaults.withCredentials = false; // withCredentials 전역 설정
// export const axiosLoc = axios.create({
//     baseURL: 'http://49.254.169.98:8090/',
//     headers: {
//         // 'Access-Control-Allow-Origin': '*',
//         'content-type': 'application/x-www-form-urlencoded',
//         'Access-Control-Allow-Credentials': true,
//         // 'content-type': 'application/json',
//         // 'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS'
//     },
//     timeout: 50000,
//     withCredentials: true,
// })

let currLang = "en-US"
export const getColumnMenu = function() {
	return i18nMap;
	/*    let map = new Map();
		axiosApi.post("/i18n.do").then((result) => {
			const list = result.data.menu
			currLang = list[0].lang
			list.forEach((item) => {
				map.set(item.code, item.message)
			})
		})
		return map
		*/
}

/**
 * 데이트 타임피커
 * @param element
 * @returns {*|jQuery}
 */
export const getDateTimePicker = function(element) {
	// setTimeout(() => {
	//     jQuery.datetimepicker.setLocale(currLang)

	$(element).datetimepicker();
	jQuery(element).datetimepicker({
		timepicker: true,
		//inline:false,
		format: 'Y-m-d H:i',
		step: 10
	});

	jQuery(element).bind("click", function(event) {
		jQuery(element).datetimepicker('show');
	});
	// }, 1000);
}

export function setDateTimePicker(textid, imgid) {
	$('#' + textid).datetimepicker({
		timepicker: true,
		format: 'Y-m-d H:i',
		step: 10
	});

	$("#" + imgid).bind("click", function(event) {
		$("#" + textid).datetimepicker('show');
	});
}

/**
 * 데이트 타임피커(년, 월, 일)
 * @param element
 * @returns {*|jQuery}
 */
export const getDatePicker = function(element) {
	// setTimeout(() => {
	//     jQuery.datetimepicker.setLocale(currLang)

	$(element).datetimepicker();
	jQuery(element).datetimepicker({
		timepicker: false,
		format: 'Y-m-d',
	});

	jQuery(element).bind("click", function(event) {
		jQuery(element).datetimepicker('show');
	});
	// }, 1000);
}

export function setDatePicker(textid, imgid) {
	$('#' + textid).datetimepicker({
		timepicker: false,
		format: 'Y-m-d'
	});

	$("#" + imgid).bind("click", function(event) {
		$("#" + textid).datetimepicker('show');
	});
}

// 검색기간 date로 변환
export const createDate = function(dateId, hourId, minuteId) {
	// 각각의 input 값 가져오기
	let date = $("#" + dateId).val();   // 날짜 값
	let hour = $("#" + hourId).val();   // 시간 값
	let minute = $("#" + minuteId).val(); // 분 값

	// Date 객체 생성
	let resultDate = new Date(date);

	// 시간과 분 설정
	resultDate.setHours(hour);
	resultDate.setMinutes(minute);

	return resultDate; // Date 객체 반환
}
//IE11에도 적용되는 날짜형식 변환(Date 객체 사용할때)
export const getDateTime2SeparatorforDate = function(datetime) {
	let str = "";

	if (datetime.length == 14) {
		str = datetime.substring(0, 4) + "-" +
			datetime.substring(4, 6) + "-" +
			datetime.substring(6, 8) + "T" +
			datetime.substring(8, 10) + ":" +
			datetime.substring(10, 12) + " " +
			datetime.substring(12, 14) + "+09:00";
	} else if (datetime.length == 12) {
		str = datetime.substring(0, 4) + "-" +
			datetime.substring(4, 6) + "-" +
			datetime.substring(6, 8) + "T" +
			datetime.substring(8, 10) + ":" +
			datetime.substring(10, 12) + "+09:00";
	} else if (datetime.length == 10) {
		str = datetime.substring(0, 4) + "-" +
			datetime.substring(4, 6) + "-" +
			datetime.substring(6, 8) + "T" +
			datetime.substring(8, 10) + ":00+09:00";
	} else if (datetime.length == 8) {
		str = datetime.substring(0, 4) + "-" +
			datetime.substring(4, 6) + "-" +
			datetime.substring(6, 8) + "T00:00+09:00";
	}

	return str;
}

/* 검색 기간 설정 */
export const searchDateLimit = function(sdt, edt) {
	const sTime = sdt.getTime();
	const eTime = edt.getTime();
	const gap = 14;

	const dtTime = Math.ceil((eTime - sTime) / 24 / 60 / 60 / 1000);

	if (edt < sdt) {
		cuteToast({
			type: "error",
			message: sessionStorage.getItem("MSG-DATETIME.err"),
			timer: 5000
		});
		return false;
	} else if (dtTime > gap) {
		let str = sessionStorage.getItem("MSG.view.down.period");
		let newStr = str.replace("*", gap);
		cuteToast({
			type: "error",
			message: newStr,
			timer: 5000
		});
		return false;
	} else {
		return true;
	}
}

/* 검색 기간 설정 */
export const searchDateLimitGap = function(sdt, edt, gap) {
	const sTime = sdt.getTime();
	const eTime = edt.getTime();
	const dtTime = Math.ceil((eTime - sTime) / 24 / 60 / 60 / 1000);

	if (edt < sdt) {
		cuteToast({
			type: "error",
			message: sessionStorage.getItem("MSG-DATETIME.err"),
			timer: 5000
		});
		return false;
	} else if (dtTime > gap) {
		let str = sessionStorage.getItem("MSG.view.down.period");
		let newStr = str.replace("*", gap);
		if (gap < 365) {
			cuteToast({
				type: "error",
				message: newStr,
				timer: 5000
			});
		}
		return false;
	} else {
		return true;
	}
}

export const searchDateLimitYear = function(sdt, edt, gap) {
	const sTime = sdt.getTime();
	const eTime = edt.getTime();
	const dtTime = Math.ceil((eTime - sTime) / 24 / 60 / 60 / 1000);
	const years = 365 * gap;

	if (edt < sdt) {
		cuteToast({
			type: "error",
			message: sessionStorage.getItem("MSG-DATETIME.err"),
			timer: 5000
		});
		return false;
	} else if (dtTime > years) {
		let str = sessionStorage.getItem("MSG.view.down.period.year");
		let newStr = str.replace("*", gap);
		cuteToast({
			type: "error",
			message: newStr,
			timer: 5000
		});
		return false;
	} else {
		return true;
	}
}

export function createRowHeight() {
	const height = 30
	const option = { rowHeight: height };

	// If the height is less than 40, minRowHeight should be set.
	if (height < 40) option.minRowHeight = height;

	return option;
}

export function selectMakeHour(element, getHour) {
	const searchHourElement = document.getElementById(element);

	// 00부터 23까지의 시간 옵션을 추가
	for (let i = 0; i < 24; i++) {
		const option = document.createElement('option');
		const value = (i < 10 ? '0' : '') + i; // 10 미만의 값은 앞에 0을 추가
		option.text = value;
		option.value = value;
		searchHourElement.appendChild(option);

		// 파라미터가 getMin이면 해당 값이 선택된 상태로 설정
		if (value === getHour) {
			option.selected = true;
		}
	}
}

export function selectMakeMin(element, getMin) {
	const searchMinElement = document.getElementById(element);

	// 00부터 50까지 10분 단위로 옵션 값을 생성하여 추가
	for (let i = 0; i <= 50; i += 10) {
		const option = document.createElement('option');
		const value = `${i < 10 ? '0' : ''}${i}`; // 10 미만의 값은 앞에 0을 추가
		option.text = value;
		option.value = value;
		searchMinElement.appendChild(option);

		// 파라미터가 getMin이면 해당 값이 선택된 상태로 설정
		if (getMin === value) {
			option.selected = true;
		}
	}
}

/**
 * select -> option 자동으로 만들기
 */
export function createSelectBox(id, name, listData) {
	// let select = document.createElement('select');
	// select.id = id;
	// select.name = name;
	let select = document.querySelector(`#${id}`)

	//최상위 전체 option 삽입
	let option = document.createElement("option");
	option.value = "ALL";
	option.text = "All";
	select.appendChild(option);

	for (const i in listData) {
		let option = document.createElement("option");
		option.value = listData[i].value;
		option.text = listData[i].text;
		select.appendChild(option);
	}

	return select;
}

/**
 * select -> option 자동으로 만들기
 */
export function createSelectBoxAndOptions(selectId, listData) {
	let select = document.querySelector(`#${selectId}`)
	let option = select.querySelectorAll("option");
	option.forEach((option, index, array) => {
		select.removeChild(option);
	})

	listData.forEach((data, index) => {
		let option = document.createElement("option");
		if (typeof data.wlobscd === 'undefined')
			option.value = data.wqobscd;
		else
			option.value = data.wlobscd;
		option.text = data.obsnm;
		if (index === 0)
			option.selected = true;
		select.appendChild(option);
	})
}

/**
 * select -> option 자동으로 만들기
 * https://negabaro.github.io/archive/js-isEmpty 참고
 */

export function appendSelectBoxAndOptions(selectId, listData) {
	let select = document.querySelector(`#${selectId}`)
	let option = select.querySelectorAll("option");
	option.forEach((option, index, array) => {
		select.removeChild(option);
	})

	listData.forEach((data, index) => {
		let option = document.createElement("option");
		// console.log(data.wlobscd, data.wqobscd, data.obsnm)

		if (!!data.wlobscd)
			option.value = data.wlobscd;
		else if (!!data.rfobscd)
			option.value = data.rfobscd;
		else if (!!data.fwobscd)
			option.value = data.fwobscd;
		else
			option.value = data.obsnm;
		option.text = data.obsnm;

		select.appendChild(option);
	})
}

export class CustomTextEditor {
	constructor(props) {
		const el = document.createElement('input');
		const { maxLength } = props.columnInfo.editor.options;

		el.type = 'number';
		el.maxLength = maxLength;
		el.value = String(props.value);

		this.el = el;
	}
	getElement() {
		return this.el;
	}
	getValue() {
		return this.el.value;
	}
	mounted() {
		this.el.select();
	}
}

export function isChecked(key, value) {
	const val = document.getElementById(key)
	if (val != null) {
		val.value = value
	} else {
		const list = document.getElementsByName(key)
		list.forEach(ra => {
			if (ra.value === value)
				ra.checked = true
			else
				ra.checked = false
		})
	}
}

export function hex2rgb(hex) {
	let validHEXInput = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (!validHEXInput) {
		return false;
	}
	let output = {
		r: parseInt(validHEXInput[1], 16),
		g: parseInt(validHEXInput[2], 16),
		b: parseInt(validHEXInput[3], 16),
	};
	// return output;
	return `rgb(${output.r},${output.g},${output.b})`;
}

export function hex2rgba(hex, opacity) {
	let validHEXInput = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (!validHEXInput) {
		return false;
	}
	let output = {
		r: parseInt(validHEXInput[1], 16),
		g: parseInt(validHEXInput[2], 16),
		b: parseInt(validHEXInput[3], 16),
	};
	// return output;
	return `rgba(${output.r},${output.g},${output.b}, ${opacity})`;
}

export function rgb2hex(r, g, b) {
	try {
		const rHex = parseInt(r).toString(16).padStart(2, '0');
		const gHex = parseInt(g).toString(16).padStart(2, '0');
		const bHex = parseInt(b).toString(16).padStart(2, '0');
	} catch (e) {
		return false;
	}
	if (rHex.length > 2 || gHex.length > 2 || bHex.length > 2) return false;
	return '#' + rHex + gHex + bHex;
}
/*정규식을 이용하여 문자열에서 숫자만 추출*/
export function chkNumber(str) {
	let res;
	res = str.replace(/[^0-9]/g, "");
	return res;
}

/**
 * 빈 문자열, 빈 Obejct, Array, 숫자에 관한 유효성 검사 함수
 *
 * @param {String} 문자열
 * @return {Boolean} true/false
 */
export function isEmpty(data) {
	if (typeof (data) === 'object') {
		if (!data) {
			return true;
		} else if (JSON.stringify(data) === '{}' || JSON.stringify(data) === '[]') {
			return true;
		}
		return false;
	} else if (typeof (data) === 'string') {
		if (!data.trim()) {
			return true;
		}
		return false;
	} else if (typeof (data) === 'undefined') {
		return true;
	} else if (isNaN(data) === true) {
		return true;
	} else {
		return false;
	}
}
/**
 * 소수를 소수점 이하 특정 자리수까지 0으로 채워서 표시
 *
 * @param {Number} 값
 * @return {Boolean} 소수점 자리수
 */
export function getFloatFixed(value, fixed) {
	return parseFloat(Math.round(value * 100) / 100).toFixed(fixed);
};

export function createMap(value) {
	const map = new Map();

	value.forEach(function(v, i) {
		map.set(v.key, v.value)

	});
	return map;
}

export const changeMoment = function(ymdhm) {
	return moment(ymdhm, "YYYYMMDDHHmm", true);
}
export const changeYmdhm = function(ymdhm) {
	const val = moment(ymdhm, "YYYYMMDDHHmm", true);
	return Date.UTC(moment(val).get('year'), moment(val).get('month'), moment(val).get('date'), moment(val).get('hour'), moment(val).get('minute'))
}

/**
 * 퍼센트 계산
 * @param num
 * @param percentage
 * @returns {number}
 */
export function calPercnt(num, percentage) {
	const result = num * (percentage / 100);
	return parseFloat(result.toFixed(2));
}

/**
 * 팝업에 사용할 DIV 
 *
 * @param {String} code 코드
 */
export const createPopupDiv = function(code) {
	let elDiv = document.createElement("div");
	elDiv.id = `popup_${code}`;
	elDiv.style.width = '860px';
	elDiv.style.height = '400px';
	return elDiv
}

export const createCctvPopupDiv = function(code) {

	let oldPlayer = document.getElementById(`my_video`); // 기존에 있는 비디오 태그 초기화
	if (oldPlayer) {
		videojs(oldPlayer).dispose();
	}

	let elDiv = document.createElement("div");
	elDiv.id = `popup_${code}`;
	elDiv.style.width = '715px';
	elDiv.style.height = '406px';

	let video = document.createElement('video');
	video.style.width = '100%';
	video.style.height = '100%';
	video.setAttribute('id', `my_video`); // `my_video_${code}`
	video.setAttribute('class', 'video-js vjs-default-skin');
	video.setAttribute('autoplay', true);
	video.setAttribute('muted', true);
	video.setAttribute('playsinline', true);
	video.setAttribute('controls', 'controls');
	video.setAttribute('preload', 'auto');
	video.setAttribute('data-setup', JSON.stringify({
		"controls": true,
		"loop": true,
		"autoplay": true,
		"preload": "true",
		//"width": "785%", // 785% 
		//"height": "440%", // 440%
	}));

	elDiv.appendChild(video)

	return elDiv
}

export const createCustomDiv = function(id, width, height) {
	let elDiv = document.createElement("div");
	elDiv.id = `${id}`
	elDiv.style.width = `${width}px`
	elDiv.style.height = `${height}px`
	elDiv.style.padding = '1px 1px 1px 1px'
	return elDiv
}

export const getNameColor = function(name) {
	let color = alarm_color[0];
	alarm_name.forEach((v, i) => {
		if (v === name) {
			color = alarm_color[i]
		}
	})
	return color;
}

/**
 * 검색기간 date type에 시간세팅 (1일 간격)
 */
export const set1DayTime2sc = function() {

	let lsttm = document.getElementById("lsttm").value;

	let eYMD = lsttm.substring(0, 4) + '-' + lsttm.substring(4, 6) + '-' + lsttm.substring(6, 8);
	let eHH = lsttm.substring(8, 10);
	let eMI = lsttm.substring(10, 12);

	document.getElementById("scEDate").value = `${eYMD}`
	document.getElementById("scEHour").value = `${eHH}`
	document.getElementById("scEMin").value = `${eMI}`

	let year = lsttm.substr(0, 4);
	let month = lsttm.substr(4, 2);
	let day = lsttm.substr(6, 2);
	let hour = lsttm.substr(8, 2);
	let minute = lsttm.substr(10, 2);

	let date = new Date(year, month - 1, day, hour, minute);
	date.setHours(date.getHours() - 24);

	var sYear = date.getFullYear();
	var sMonth = ("0" + (date.getMonth() + 1)).slice(-2);
	var sDay = ("0" + date.getDate()).slice(-2);
	var sHour = ("0" + date.getHours()).slice(-2);
	var sMinute = ("0" + date.getMinutes()).slice(-2);

	document.getElementById("scSDate").value = `${sYear}-${sMonth}-${sDay}`
	document.getElementById("scSHour").value = `${sHour}`
	document.getElementById("scSMin").value = `${sMinute}`
}

/**
 * 검색기간 date type에 시간세팅 (1개월 간격)
 */
export const set1MonthTime2sc = function() {

	let lsttm = document.getElementById("lsttm").value;

	let eYMD = lsttm.substring(0, 4) + '-' + lsttm.substring(4, 6) + '-' + lsttm.substring(6, 8);
	let eHH = lsttm.substring(8, 10);
	let eMI = lsttm.substring(10, 12);

	document.getElementById("scEDate").value = `${eYMD}`
	document.getElementById("scEHour").value = `${eHH}`
	document.getElementById("scEMin").value = `${eMI}`

	let year = lsttm.substr(0, 4);
	let month = lsttm.substr(4, 2);
	let day = lsttm.substr(6, 2);
	let hour = lsttm.substr(8, 2);
	let minute = lsttm.substr(10, 2);

	let date = new Date(year, month - 1, day, hour, minute);
	date.setMonth(date.getMonth() - 1);

	var sYear = date.getFullYear();
	var sMonth = ("0" + (date.getMonth() + 1)).slice(-2);
	var sDay = ("0" + date.getDate()).slice(-2);
	var sHour = ("0" + date.getHours()).slice(-2);
	var sMinute = ("0" + date.getMinutes()).slice(-2);

	document.getElementById("scSDate").value = `${sYear}-${sMonth}-${sDay}`
	document.getElementById("scSHour").value = `${sHour}`
	document.getElementById("scSMin").value = `${sMinute}`
}

/**
 * scS 와 scE를 YMDHM 형식으로 변경
 */
export const getPeriodSc2StringTime = function() {

	let sYMD = document.getElementById("scSDate").value
	sYMD = sYMD.substring(0, 4) + sYMD.substring(5, 7) + sYMD.substring(8, 10)
	const sHour = document.getElementById("scSHour").value
	const sMin = document.getElementById("scSMin").value

	let eYMD = document.getElementById("scEDate").value
	eYMD = eYMD.substring(0, 4) + eYMD.substring(5, 7) + eYMD.substring(8, 10)
	const eHour = document.getElementById("scEHour").value
	const eMin = document.getElementById("scEMin").value

	const sdt = `${sYMD}` + `${sHour}` + `${sMin}`
	const edt = `${eYMD}` + `${eHour}` + `${eMin}`

	return { sdt: sdt, edt: edt }
}

/**
 * sc를 YMDH 형식으로 변경
 */
export const getPeriodSc2YMDH = function() {

	let YMD = document.getElementById("scDate").value
	YMD = YMD.substring(0, 4) + YMD.substring(5, 7) + YMD.substring(8, 10)
	const Hour = document.getElementById("scHour").value

	const ymdh = `${YMD}` + `${Hour}`

	return { ymdh: ymdh }
}

/**
 * sc를 기준으로 1일 기간의 YMDHM 형식의 시작일 종료일 리턴 
 */
export const makeSdtEdtFromSc = function() {

	const ymdhm = getSc2StringTime();
	const year = ymdhm.substring(0, 4);
	const month = ymdhm.substring(4, 6);
	const day = ymdhm.substring(6, 8);
	const hour = ymdhm.substring(8, 10);
	const minute = ymdhm.substring(10, 12);

	let date = new Date(year, month - 1, day, hour, minute);
	date.setHours(date.getHours() - 24); // 24시간전 시간 생성

	let sYear = date.getFullYear();
	let sMonth = ("0" + (date.getMonth() + 1)).slice(-2);
	let sDay = ("0" + date.getDate()).slice(-2);
	let sHour = ("0" + date.getHours()).slice(-2);
	let sMinute = ("0" + date.getMinutes()).slice(-2);

	return { sdt: `${sYear}` + `${sMonth}` + `${sDay}` + `${sHour}` + `${sMinute}`, edt: ymdhm };
}

/**
 * 검색일자 date type에 시간세팅
 */
export const setTime2sc = function() {

	let lsttm = document.getElementById("lsttm").value;

	let eYMD = lsttm.substring(0, 4) + '-' + lsttm.substring(4, 6) + '-' + lsttm.substring(6, 8);
	let eHH = lsttm.substring(8, 10);
	let eMI = lsttm.substring(10, 12);

	document.getElementById("scDate").value = `${eYMD}`
	document.getElementById("scHour").value = `${eHH}`
	document.getElementById("scMin").value = `${eMI}`
}

/**
 * 검색일자 date type에 시작시간 세팅
 */
export const setTimeSdt = function() {

	let sdt = document.getElementById("sdt").value;

	let eYMD = sdt.substring(0, 4) + '-' + sdt.substring(4, 6) + '-' + sdt.substring(6, 8);
	let eHH = sdt.substring(8, 10);
	let eMI = sdt.substring(10, 12);

	document.getElementById("scSDate").value = `${eYMD}`
	document.getElementById("scSHour").value = `${eHH}`
	document.getElementById("scSMin").value = `${eMI}`
}

/**
 * 검색일자 date type에 종료시간 세팅
 */
export const setTimeEdt = function() {

	let lsttm = document.getElementById("lsttm").value;

	let eYMD = lsttm.substring(0, 4) + '-' + lsttm.substring(4, 6) + '-' + lsttm.substring(6, 8);
	let eHH = lsttm.substring(8, 10);
	let eMI = lsttm.substring(10, 12);

	document.getElementById("scEDate").value = `${eYMD}`
	document.getElementById("scEHour").value = `${eHH}`
	document.getElementById("scEMin").value = `${eMI}`
}

/**
 * 검색일자를 YMDHM 형식으로 변경
 */
export const getSc2StringTime = function() {

	let YMD = document.getElementById("scDate").value
	YMD = YMD.substring(0, 4) + YMD.substring(5, 7) + YMD.substring(8, 10)
	const Hour = document.getElementById("scHour").value
	const Min = document.getElementById("scMin").value

	const ymdhm = `${YMD}` + `${Hour}` + `${Min}`

	return ymdhm;
}

/**
 * 팝업에 현재 검색일자 기준으로 1일 기간의 Input Date 세팅
 */
export const setPopupSdtEdt = function() {

	const ymdhm = getSc2StringTime();
	const eYear = ymdhm.substring(0, 4);
	const eMonth = ymdhm.substring(4, 6);
	const eDay = ymdhm.substring(6, 8);
	const eHour = ymdhm.substring(8, 10);
	const eMinute = ymdhm.substring(10, 12);

	let date = new Date(eYear, eMonth - 1, eDay, eHour, eMinute);
	date.setHours(date.getHours() - 24); // 24시간전 시간 생성

	let sYear = date.getFullYear();
	let sMonth = ("0" + (date.getMonth() + 1)).slice(-2);
	let sDay = ("0" + date.getDate()).slice(-2);
	let sHour = ("0" + date.getHours()).slice(-2);
	let sMinute = ("0" + date.getMinutes()).slice(-2);

	document.getElementById("scSDate").value = `${sYear}-${sMonth}-${sDay}`
	document.getElementById("scSHour").value = `${sHour}`
	document.getElementById("scSMin").value = `${sMinute}`

	document.getElementById("scEDate").value = `${eYear}-${eMonth}-${eDay}`
	document.getElementById("scEHour").value = `${eHour}`
	document.getElementById("scEMin").value = `${eMinute}`
}

/**
 * 주어진 날자 사이의 간격을 10분 간격의 배열로 리턴한다
 * @param {String} start pattern : '999912312250'
 * @param {String} end   pattern : '999912312350'
 * @returns {ArrayList}  pattern : ['999912312250', '999912312300', '999912312310', ... ]
 */
export const get10mTimeJsonArray = function(sdt, edt) {

	let start = sdt.substring(0, 4) + "-" + sdt.substring(4, 6) + "-" + sdt.substring(6, 8) + " " + sdt.substring(8, 10) + ":" + sdt.substring(10, 12)
	let end = edt.substring(0, 4) + "-" + edt.substring(4, 6) + "-" + edt.substring(6, 8) + " " + edt.substring(8, 10) + ":" + edt.substring(10, 12)

	let resultArr = [];
	let start_time = new Date(start);
	let end_time = new Date(end);

	while (start_time.getTime() <= end_time.getTime()) {
		let year = start_time.getFullYear();
		let month = (start_time.getMonth() + 1);
		let day = start_time.getDate();
		let hour = start_time.getHours();
		let min = start_time.getMinutes();
		
		month = month < 10 ? '0' + month : month;	
		day = day < 10 ? '0' + day : day;	
		hour = hour < 10 ? '0' + hour : hour;	
		min = min < 10 ? '0' + min : min;
		
		resultArr.push({ ymdhm: `${year}${month}${day}${hour}${min}` }); // json 형식으로 push
		start_time.setMinutes(start_time.getMinutes() + 10);
	}

	return resultArr;
}

/**
 * 주어진 날자 사이의 간격을 1시간 간격의 배열로 리턴한다
 * @param {String} start pattern : '999912302350'
 * @param {String} end   pattern : '999912312350'
 * @returns {ArrayList}  pattern : ['999912302350', '999912310050', '999912310150', ... ]
 */
export const get1hTimeJsonArray = function(sdt, edt) {

	let start = sdt.substring(0, 4) + "-" + sdt.substring(4, 6) + "-" + sdt.substring(6, 8) + " " + sdt.substring(8, 10) + ":" + "00";
	let end = edt.substring(0, 4) + "-" + edt.substring(4, 6) + "-" + edt.substring(6, 8) + " " + edt.substring(8, 10) + ":" + "00";

	let resultArr = [];
	let start_time = new Date(start);
	let end_time = new Date(end);

	while (start_time.getTime() <= end_time.getTime()) {
		let year = start_time.getFullYear();
		let month = (start_time.getMonth() + 1);
		let day = start_time.getDate();
		let hour = start_time.getHours();
		let min = start_time.getMinutes();
		
		month = month < 10 ? '0' + month : month;
		day = day < 10 ? '0' + day : day;
		hour = hour < 10 ? '0' + hour : hour;
		min = min < 10 ? '0' + min : min;
		
		resultArr.push({ ymdhm: `${year}${month}${day}${hour}${min}`}); // json 형식으로 push
		start_time.setHours(start_time.getHours() + 1);
	}

	return resultArr;
}

//"202304010300" => "2023-04-01 03:00"
export const getDateTime2Separator = function(datetime, separator) {
	var str = "";

	if (datetime != null && datetime != "") {
		if (datetime.length == 14) {
			str = datetime.substring(0, 4) + separator +
				datetime.substring(4, 6) + separator +
				datetime.substring(6, 8) + " " +
				datetime.substring(8, 10) + ":" +
				datetime.substring(10, 12) + ":" +
				datetime.substring(12, 14);
		}
		else if (datetime.length == 12) {
			str = datetime.substring(0, 4) + separator +
				datetime.substring(4, 6) + separator +
				datetime.substring(6, 8) + " " +
				datetime.substring(8, 10) + ":" +
				datetime.substring(10, 12);
		}
		else if (datetime.length == 10) {
			str = datetime.substring(0, 4) + separator +
				datetime.substring(4, 6) + separator +
				datetime.substring(6, 8) + " " +
				datetime.substring(8, 10);
		}
		else if (datetime.length == 8) {
			str = datetime.substring(0, 4) + separator +
				datetime.substring(4, 6) + separator +
				datetime.substring(6, 8);
		}
	}

	return str;
}

// 날짜형식 변환 ("9999/99/99 00:00" -> "999999990000")
export const getDateTime2Blank = function getDateTime2Blank(datetime) {
	var str = "";

	if (datetime.length == 16) {
		str = datetime.substring(0, 4) +
			datetime.substring(5, 7) +
			datetime.substring(8, 10) +
			datetime.substring(11, 13) +
			datetime.substring(14, 16);
	} else if (datetime.length == 10) {
		str = datetime.substring(0, 4) +
			datetime.substring(5, 7) +
			datetime.substring(8, 10);
	} else if (datetime.length == 7) {
		str = datetime.substring(0, 4) +
			datetime.substring(5, 7);
	} else if (datetime.length == 4) {
		str = datetime;
	}

	return str;
}

export const setCctvVideo = (info, elDiv) => {

	let url = info.url;

	const player = videojs(`my_video`, {
		controlBar: {
			fullscreenToggle: true
		},
	});
	player.ready(function() {
		player.src({
			src: url, // HLS 주소 입력
			type: 'application/x-mpegURL'
		});
	});
	player.getCache();
	player.readyState();
	player.currentSources();
}
/**
 * form
 * items에 넘어온 값을 키 요소에 주입
 * @param items
 */
export const elementMapping = (form, items) => {
	if (form != null) {
		const formId = document.getElementById(form)
		for (const key in items) {
			try {
				formId.querySelector(`#{key}`).value = items[key]
				// console.log(key + ":" + items[key])
			} catch (e) {
			}
		}
	} else {
		for (const key in items) {
			try {
				document.getElementById(key).value = items[key]
				// console.log(key + ":" + items[key])
			} catch (e) {
			}
		}
	}
}

/**
 * 관리기관 select 박스 생성
 */
export const initAgcif = function() {

	try {
		const agclist = document.getElementById('agclist');
		if (agclist) {
			while (agclist.firstChild) {
				agclist.removeChild(agclist.firstChild);
			}
		}
	} catch (err) {

	}
	try {
		const popAgclist = document.getElementById('popAgclist');
		if (popAgclist) {
			while (popAgclist.firstChild) {
				popAgclist.removeChild(popAgclist.firstChild);
			}
		}
	} catch (err) {

	}
	apiAxios.post('/common/cdifdtl/01') // 01번 -> 관리기관코드 리스트
		.then(info => {
			try {
				let default_ = document.createElement('option');
				default_.value = 'all'
				default_.innerText = 'Agency'

				const agclist = document.getElementById('agclist');
				agclist.appendChild(default_)
				info.forEach((val, idx) => {
					const option = document.createElement('option')
					option.value = val.dtlcd;
					option.innerText = val.cpt;
					agclist.appendChild(option)
				})

				default_ = document.createElement('option');
				default_.value = 'all'
				default_.innerText = 'Agency'

				const popAgclist = document.getElementById('popAgclist');
				popAgclist.appendChild(default_)
				info.forEach((val, idx) => {
					const option = document.createElement('option')
					option.value = val.dtlcd;
					option.innerText = val.cpt;
					popAgclist.appendChild(option)
				})

			} catch (err) {

			}
		})
}

/**
 * 관리기관, 유역코드 파라미터 생성
 */
export const makeIfParam = function() {

	let agccdList = document.getElementById('agclist');
	let bsncdList = document.getElementById('bsnlist');
	let agccd;
	let bsncd;

	if (agccdList) {
		agccd = agccdList.value;
		if (agccd == null || agccd == '') agccd = 'all';
	}
	if (bsncdList) {
		bsncd = bsncdList.value;
		if (bsncd == null || bsncd == '') bsncd = 'all';
	}

	const params = {
		"agccd": agccd,
		"bsncd": bsncd
	};

	return params;
}

/**
 * 유역 select 박스 생성
 */
export const initBasinif = function() {

	try {
		const bsnlist = document.getElementById('bsnlist');
		if (bsnlist) {
			while (bsnlist.firstChild) {
				bsnlist.removeChild(bsnlist.firstChild);
			}
		}
	} catch (err) {

	}
	try {
		const popBsnlist = document.getElementById('popBsnlist');
		if (popBsnlist) {
			while (popBsnlist.firstChild) {
				popBsnlist.removeChild(popBsnlist.firstChild);
			}
		}
	} catch (err) {

	}

	apiAxios.post('/basin/Fbs/Info')
		.then(info => {
			try {
				let default_ = document.createElement('option');
				default_.value = 'all'
				default_.innerText = 'Basin'

				const bsnlist = document.getElementById('bsnlist');
				bsnlist.appendChild(default_)
				info.forEach((val, idx) => {
					const option = document.createElement('option')
					option.value = val.fbscd;
					option.innerText = val.fbsnm;
					bsnlist.appendChild(option)
				})

				default_ = document.createElement('option');
				default_.value = 'all'
				default_.innerText = 'Basin'

				const popBsnlist = document.getElementById('popBsnlist');
				popBsnlist.appendChild(default_)
				info.forEach((val, idx) => {
					const option = document.createElement('option')
					option.value = val.fbscd;
					option.innerText = val.fbsnm;
					popBsnlist.appendChild(option)
				})
			} catch (err) {

			}
		})
}

/**
 * div 마우스 드래그 이벤트
 */
export const divMouseDragEvent = (elDiv) => {

	let isDragging = null;
	let originLeft = null;
	let originTop = null;
	let originX = null;
	let originY = null;

	elDiv.addEventListener('mousedown', (event) => {
		isDragging = true;
		originX = event.clientX;
		originY = event.clientY;
		originLeft = elDiv.offsetLeft;
		originTop = elDiv.offsetTop;
	})

	document.addEventListener('mouseup', (event) => {
		isDragging = false;
	})

	document.addEventListener('mousemove', (event) => {
		if (isDragging) {
			const diffX = event.clientX - originX;
			const diffY = event.clientY - originY;
			elDiv.style.left = originLeft + diffX + "px";
			elDiv.style.top = originTop + diffY + "px";
		}
	})
}

export const subtractOneDay = function(dateTimeStr) {
	// Parse the date-time string
	const year = parseInt(dateTimeStr.slice(0, 4), 10);
	const month = parseInt(dateTimeStr.slice(4, 6), 10) - 1; // JS months are 0-indexed
	const day = parseInt(dateTimeStr.slice(6, 8), 10);
	const hours = parseInt(dateTimeStr.slice(8, 10), 10);
	const minutes = parseInt(dateTimeStr.slice(10, 12), 10);

	// Create a Date object
	const date = new Date(year, month, day, hours, minutes);

	// Subtract one day in milliseconds
	date.setDate(date.getDate() - 1);

	// Format back to 'YYYYMMDDHHmm'
	const newDateTimeStr = date.getFullYear().toString().padStart(4, '0') +
		(date.getMonth() + 1).toString().padStart(2, '0') +
		date.getDate().toString().padStart(2, '0') +
		date.getHours().toString().padStart(2, '0') +
		date.getMinutes().toString().padStart(2, '0');

	return newDateTimeStr;
}

/**
 * divMouseDragEvent 이벤트에서 특정 요소는 제외하기
 */
const divMouseDragEventDel = (elDiv) => {
	elDiv.addEventListener('mousedown', (event) => {
		event.stopPropagation();
	})
	elDiv.addEventListener('mouseup', (event) => {
		//event.stopPropagation();  -> 하이차트 줌 이벤트와 충돌됨... 
	})
	elDiv.addEventListener('mousemove', (event) => {
		event.stopPropagation();
	})
}

// 맵 Div는 팝업 드래그이벤트에서 제외하기
const mapEl = document.getElementById('map');
if (mapEl) divMouseDragEventDel(mapEl);

// 차트 Div는 팝업 드래그이벤트에서 제외하기
const chartEl = document.getElementById('popChart');
if (chartEl) divMouseDragEventDel(chartEl)

// 차트 Div는 팝업 드래그이벤트에서 제외하기
const chartEl_1 = document.getElementById('popChart_1');
if (chartEl_1) divMouseDragEventDel(chartEl_1);

// 차트 Div는 팝업 드래그이벤트에서 제외하기
const chartEl_2 = document.getElementById('popChart_2');
if (chartEl_2) divMouseDragEventDel(chartEl_2);

// 팝업 마우스 드래그 드랍 이벤트
const popupDiv = document.getElementById('popup');
if (popupDiv) divMouseDragEvent(popupDiv);

async function getDownloadPeriod(type = "month") {
	const response = await fetch(`/api/config/download-period?type=${type}`);
	const data = await response.json();
	return data.periodDays;
}

export async function checkDateDiff(sdt, edt, type) {
	const periodDays = await getDownloadPeriod(type);

	// 시간 성분 제거 (정규화)
	const s = new Date(sdt.getTime());
	const e = new Date(edt.getTime());
	s.setHours(0, 0, 0, 0);
	e.setHours(0, 0, 0, 0);

	const msPerDay = 1000 * 60 * 60 * 24;
	const diffDaysInclusive = Math.floor((e.getTime() - s.getTime()) / msPerDay) + 1;
	let str = "";
	let result = "";
	if(type == "year") {
		str = sessionStorage.getItem("MSG.view.down.period.year");
		result = str.replace(/\*/g, 1);
	} else {
		str = sessionStorage.getItem("MSG.view.down.period");
		result = str.replace(/\*/g, periodDays);
	}

	if (edt < sdt) {
		cuteToast({
			type: "error",
			message: sessionStorage.getItem("MSG-DATETIME.err"),
			timer: 5000
		});
		return false;
	} else if (diffDaysInclusive > periodDays) {
		cuteToast({
			type: "error",
			message: result,
			timer: 5000
		});
		return false;
	} else if (Number.isNaN(s) || Number.isNaN(e)) {
		cuteToast({
			type: "warning",
			title: result,
			message: ' ',
			buttonText: sessionStorage.getItem("TITLE.cnfirm"),
		})

		return false;
	} else {
		return true;
	}
}

export { axios, apiAxios as axiosApi, axiosLoc, currLang }